<template>
	<svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.3166 17.67L13.3336 15.8017L3.65422 24.9217V16.1908H0.841797V29.4398H14.9039V26.79H5.63717L15.3166 17.67Z"
			fill="white"
		/>
		<path
			d="M17.115 12.2373L19.098 14.1056L28.7774 4.98551L28.7774 13.7164L31.5898 13.7164L31.5898 0.467438L17.5277 0.467437L17.5277 3.11723L26.7945 3.11723L17.115 12.2373Z"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-expand',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss"></style>

<docs>
    IconExpand

    ```js
    <b-icon-expand />
    ```
</docs>
